import 'handsontable/dist/handsontable.full.css'
import { HotTable } from '@handsontable/vue3'
import { registerAllModules } from 'handsontable/registry'

export default defineNuxtPlugin(({ vueApp }) => {
  registerAllModules()

  vueApp.component('HotTable', HotTable)
})
